import React from "react";
import classes from "../contests.module.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];

  // Create page number array based on total pages
  // Handle the case where totalPages might not be determined yet
  const safeTotalPages = Math.max(1, totalPages || 1);

  for (let i = 1; i <= safeTotalPages; i++) {
    pageNumbers.push(i);
  }

  // Only show limited page numbers with ellipsis for better UX
  const getVisiblePageNumbers = () => {
    if (safeTotalPages <= 7) {
      return pageNumbers;
    }

    // Always show first and last page
    // Show ellipsis when needed
    if (currentPage < 5) {
      return [...pageNumbers.slice(0, 5), "...", safeTotalPages];
    } else if (currentPage > safeTotalPages - 4) {
      return [1, "...", ...pageNumbers.slice(safeTotalPages - 5)];
    } else {
      return [
        1,
        "...",
        currentPage - 1,
        currentPage,
        currentPage + 1,
        "...",
        safeTotalPages,
      ];
    }
  };

  return (
    <div className={classes ? classes.pagination : "pagination"}>
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={classes ? classes.paginationButton : "paginationButton"}
      >
        Previous
      </button>

      <div className={classes ? classes.pageNumbers : "pageNumbers"}>
        {getVisiblePageNumbers().map((page, index) => (
          <button
            key={index}
            onClick={() => (page !== "..." ? onPageChange(page) : null)}
            className={`${classes ? classes.pageNumber : "pageNumber"} ${
              page === currentPage
                ? classes
                  ? classes.activePage
                  : "activePage"
                : ""
            } ${
              page === "..." ? (classes ? classes.ellipsis : "ellipsis") : ""
            }`}
            disabled={page === "..."}
          >
            {page}
          </button>
        ))}
      </div>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === safeTotalPages}
        className={classes ? classes.paginationButton : "paginationButton"}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
